import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';

export function TailwheelEndorsement() {
  return (
    <>
      <Helmet>
        <title>Tailwheel Endorsement | Total Tailwheel</title>
        <meta
          name="description"
          content="Earn your tailwheel endorsement in 5-10 hours in our 1954 Cessna 170B. Located at Minute Man Air Field in Stow, MA, just 30 minutes from Boston."
        />
        <link rel="canonical" href="https://totaltailwheel.com/training/tailwheel-endorsement" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <PageHero title="Tailwheel Endorsement" />

        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="bg-white p-8 rounded-lg shadow-md">
                <p className="text-foreground/80 mb-4">
                  A tailwheel endorsement per{' '}
                  <a
                    href="https://www.ecfr.gov/current/title-14/chapter-I/subchapter-D/part-61/subpart-A/section-61.31#p-61.31(i)"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary underline hover:text-primary/80"
                  >
                    FAR 61.31(i)
                  </a>{' '}
                  is required to act as pilot-in-command of a conventional gear (tailwheel) aircraft. You'll learn
                  ground handling, crosswind techniques, wheel landings, and three-point landings in our 1954 Cessna 170B.
                </p>

                <p className="text-foreground/80 mb-6">
                  Most pilots complete their endorsement in <strong>5-10 hours</strong> of dual instruction. We'll work at
                  your pace until you're confident and safe in the airplane.
                </p>

                <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
                  <p className="text-sm text-foreground/70">
                    Located at <strong>Minute Man Air Field (6B6)</strong> in Stow, MA — just 30 minutes west of Boston,
                    with easy access from Route 2 and Route 495.
                  </p>
                </div>

                <div className="text-center">
                  <Link
                    to="/inquire"
                    className="inline-block bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors font-medium"
                  >
                    Inquire Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
